/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BalanceOperationControlsEntity } from '../models/BalanceOperationControlsEntity';
import type { UpdateBalanceOperationControlsDto } from '../models/UpdateBalanceOperationControlsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BalanceOperationControlsService {
  /**
   * Xem cấu hình chức năng trừ điểm
   * @returns BalanceOperationControlsEntity
   * @throws ApiError
   */
  public static balanceOperationControlsControllerGetControls(): CancelablePromise<BalanceOperationControlsEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/server-config/balance-operation-controls',
    });
  }

  /**
   * Cập nhật cấu hình chức năng trừ điểm
   * @param requestBody
   * @returns BalanceOperationControlsEntity
   * @throws ApiError
   */
  public static balanceOperationControlsControllerUpdateControls(
    requestBody: UpdateBalanceOperationControlsDto,
  ): CancelablePromise<BalanceOperationControlsEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/server-config/balance-operation-controls',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
